"use client"

import { GalleryCard } from "./GalleryCard"
import type { UIGalleryItem } from "./GalleryPage"

interface GalleryGridProps {
  items: UIGalleryItem[]
  onLikeToggle: (itemId: string) => void
  onImageClick: (item: UIGalleryItem) => void
  showLoginTooltipForImage: string | null // Changed from boolean to track specific image ID
}

export function GalleryGrid({ items, onLikeToggle, onImageClick, showLoginTooltipForImage }: GalleryGridProps) {
  if (items.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No designs found matching your filters.</p>
        <p className="text-gray-400 mt-2">Try adjusting your search criteria.</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item) => (
        <GalleryCard
          key={item.id}
          item={item}
          onLikeToggle={onLikeToggle}
          onImageClick={onImageClick}
          showLoginTooltipForImage={showLoginTooltipForImage} // Pass image ID instead of boolean
        />
      ))}
    </div>
  )
}
